module.exports = __webpack_public_path__ + "static/media/photo4.4777b9f1.png";